import qs from 'qs'

export const getParamsValues = (search: string)=>{
     const result = qs.parse(search, {
         comma: false,
         ignoreQueryPrefix: true,
      }) as {
         id?: string
      }
      return{
         id: result.id || ''
      }
}